<h2 class="mat-dialog-title" mat-dialog-title class="text-secondary">
    Update Absence</h2>
<form [formGroup]="absenceForm">
    <mat-dialog-content class="pb-2">
        <app-section-loader [loading]="loading"></app-section-loader>
        <mat-form-field>
            <mat-label>Date</mat-label>
            <input matInput formControlName="absence_date" [matDatepicker]="picker" readonly required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>


        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Tutor</mat-label>
            <mat-select formControlName="volunteer" required>
                <mat-option>
                <ngx-mat-select-search [formControl]="tutorControl" [noEntriesFoundLabel]="'No matching tutor found'"
                    placeholderLabel="Search tutor">
                </ngx-mat-select-search>
            </mat-option>
                <mat-option *ngFor="let tutor of tutorOptions" [value]="tutor.id">
                    {{tutor.first_name | titlecase}} {{ tutor.last_name | titlecase}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100" [ngClass]="lessonOptions?.length===0?'mb-4':''">
            <mat-label>Lesson</mat-label>
            <mat-select formControlName="lesson" required>
                <ngx-mat-select-search [formControl]="lessonControl" [noEntriesFoundLabel]="'No matching lesson found'"
                    placeholderLabel="Search lesson">
                </ngx-mat-select-search>
                <mat-option *ngFor="let lesson of lessonOptions" [value]="lesson.id">
                    Lesson {{lesson.lesson_plan_number}} - {{lesson.lesson_plan_name}}
                </mat-option>
            </mat-select>
            <mat-hint class="mat-error text-danger"
                *ngIf="lessonOptions?.length===0">No more lessons are pending for the student</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Reason for absence</mat-label>
            <mat-select formControlName="reason_for_absence" required>
                <mat-option *ngFor="let reason of reasons" [value]="reason.id">
                    {{reason.reason_name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-hint class="mat-error text-danger " *ngIf="showError">
            Please select another lesson and save or delete the current absence
        </mat-hint>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close (click)="dialogRef.close(false)">Cancel</button>
        <button mat-raised-button color="primary" [disabled]="!absenceForm.valid"
            (click)="updateAbsence(absenceForm.value)">Save</button>
    </mat-dialog-actions>
</form>